import React, { FC } from 'react';

interface FilterProps {
  searchPosts: (value: string) => void;
}

const AnetaPackSearchFilter: FC<FilterProps> = ({ searchPosts }) => {
  return (
    <div>
      <input
        type="text"
        placeholder="AnetaPacks"
        onChange={(event) => {
          searchPosts(event.target.value);
        }}
      />
    </div>
  );
};

export default AnetaPackSearchFilter;
